<template src="../../../public/HODOPolicy/index.htm"></template>

<script>
export default {

  name: 'Term',

  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped src="../../../public/HODOPolicy/chinhsach_files/Site.css"></style>